import type { DeclarePlatformStockInput, PlatformStock } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const declarePlatformStock = async (data: DeclarePlatformStockInput) => {
  const response = await gozokiApiWithAuth.post<PlatformStock>('/platform-stocks', data)
  return response.data
}

export const deletePlatformStock = async (id: number) => {
  await gozokiApiWithAuth.delete(`/platform-stocks/${id}`)
}

export const deletePlatformStockLog = async (id: number) => {
  await gozokiApiWithAuth.delete(`/platform-stock-logs/${id}`)
}

export const revertPlatformStockLog = async (id: number) => {
  await gozokiApiWithAuth.post(`/platform-stock-logs/${id}/revert`)
}
